import { useState } from 'react';
import { useUserSelectedBranchLocation } from './useUserSelectedBranchLocation';
import apiService from '../axios/apiService';
import { useUserClinic } from './useUserClinic';

export const usePaymentMethod = () => {
  const {
    selectedLocation,
    selectBranchLocation
  } = useUserSelectedBranchLocation();
  const { userClinic } = useUserClinic()
  const [loading, setLoading] = useState(false);

  const updatePaymentMethod = async (clinicLocationId, data) => {
    console.log("data : ", data);
    try {
      setLoading(true);
      // Update clinic location payment method on the database
      const response = await apiService.updateClinicLocationPaymentMethod(clinicLocationId, data, { clinicId: userClinic?.clinicId });
      // Update the selected location with updated data
      console.log("Clinic location updated successfully : ", response);
      selectBranchLocation({ ...selectedLocation, paymentMethod: response?.paymentMethod });
      return true;
    } catch (error) {
      console.error('Failed to update payment method:', error);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    selectedLocation,
    loading,
    updatePaymentMethod,
  };
};